export const addressToString = (address) => {
    const showAddressesLine2 = address.addressLine2
        ? ' ' + address.addressLine2
        : '';
    return (address.addressLine1 +
        showAddressesLine2 +
        ', ' +
        address.city +
        ', ' +
        address.state +
        ', ' +
        address.zipCode);
};
